export const META_KEYS = [
  { key: 'Ctrl Left', code: 'ControlLeft' },
  { key: 'Ctrl Right', code: 'ControlRight' },
  { key: 'Shift Left', code: 'ShiftLeft' },
  { key: 'Shift Right', code: 'ShiftRight' },
  { key: 'Alt Left', code: 'AltLeft' },
  { key: 'Alt Right', code: 'AltRight' },
  { key: 'Meta Left', code: 'MetaLeft' },
  { key: 'Meta Right', code: 'MetaRight' },
  { key: 'F1', code: 'F1' },
  { key: 'F2', code: 'F2' },
  { key: 'F3', code: 'F3' },
  { key: 'F4', code: 'F4' },
  { key: 'F5', code: 'F5' },
  { key: 'F6', code: 'F6' },
  { key: 'F7', code: 'F7' },
  { key: 'F8', code: 'F8' },
  { key: 'F9', code: 'F9' },
  { key: 'F10', code: 'F10' },
  { key: 'F11', code: 'F11' },
  { key: 'F12', code: 'F12' },
  { key: 'F13', code: 'F13' },
  { key: 'F14', code: 'F14' },
  { key: 'F15', code: 'F15' },
  { key: 'F16', code: 'F16' },
  { key: 'F17', code: 'F17' },
  { key: 'F18', code: 'F18' },
  { key: 'F19', code: 'F19' },
  { key: 'F20', code: 'F20' },
  { key: 'F21', code: 'F21' },
  { key: 'F22', code: 'F22' },
  { key: 'F23', code: 'F23' },
  { key: 'F24', code: 'F24' },
]

export const SPECIAL_KEYS = [
  { key: 'Tab', code: 'Tab' },
  { key: 'Escape', code: 'Escape' },
  { key: 'Enter', code: 'Enter' },
  { key: 'Backspace', code: 'Backspace' },
  { key: 'Space', code: 'Space' },
  { key: 'Minus', code: 'Minus' },
  { key: 'Equal', code: 'Equal' },
  { key: 'Arrow Right', code: 'ArrowRight' },
  { key: 'Arrow Left', code: 'ArrowLeft' },
  { key: 'Arrow Down', code: 'ArrowDown' },
  { key: 'Arrow Up', code: 'ArrowUp' },
  { key: 'Insert', code: 'Insert' },
  { key: 'Home', code: 'Home' },
  { key: 'Delete', code: 'Delete' },
  { key: 'End', code: 'End' },
  { key: 'Page Up', code: 'PageUp' },
  { key: 'Page Down', code: 'PageDown' },
  { key: 'NumLock', code: 'NumLock' },
  { key: 'Numpad 0', code: 'Numpad0' },
  { key: 'Numpad 1', code: 'Numpad1' },
  { key: 'Numpad 2', code: 'Numpad2' },
  { key: 'Numpad 3', code: 'Numpad3' },
  { key: 'Numpad 4', code: 'Numpad4' },
  { key: 'Numpad 5', code: 'Numpad5' },
  { key: 'Numpad 6', code: 'Numpad6' },
  { key: 'Numpad 7', code: 'Numpad7' },
  { key: 'Numpad 8', code: 'Numpad8' },
  { key: 'Numpad 9', code: 'Numpad9' },
  { key: 'Numpad /', code: 'NumpadDivide' },
  { key: 'Numpad *', code: 'NumpadMultiply' },
  { key: 'Numpad -', code: 'NumpadSubtract' },
  { key: 'Numpad =', code: 'NumpadEqual' },
  { key: 'Numpad +', code: 'NumpadAdd' },
  { key: 'Numpad Enter', code: 'NumpadEnter' },
  { key: 'Numpad .', code: 'NumpadDecimal' },
]

export const MEDIA_KEYS = [
  { key: 'Media Play/Pause', code: 'MediaPlayPause' },
  { key: 'Media Stop', code: 'MediaStop' },
  { key: 'Media Next Track', code: 'MediaTrackNext' },
  { key: 'Media Previous Track', code: 'MediaTrackPrevious' },
  { key: 'Media Record', code: 'MediaRecord' },
  { key: 'Media Fast Forward', code: 'MediaFastForward' },
  { key: 'Media Rewind', code: 'MediaRewind' },
  { key: 'Volume Mute', code: 'AudioVolumeMute' },
  { key: 'Volume Up', code: 'AudioVolumeUp' },
  { key: 'Volume Down', code: 'AudioVolumeDown' },
]

export type ExperimentalNavigator = Navigator & {
  keyboard: { getLayoutMap: () => Promise<LayoutMapType> }
}

export type LayoutMapType = {
  get(code: string): string | undefined
  entries(): IterableIterator<[string, string]>
}

export const getKeyboardLayoutMap = () =>
  (navigator as ExperimentalNavigator).keyboard?.getLayoutMap() ||
  Promise.resolve({
    forEach: Array().forEach,
    entries: Array().entries,
  })

export const isMetaKey = (code: string) =>
  !!META_KEYS.find((k) => k.code === code)
